import { render, staticRenderFns } from "./TabCard.vue?vue&type=template&id=59a80269&"
import script from "./TabCard.vue?vue&type=script&lang=js&"
export * from "./TabCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports